export default {"src":"/_next/static/media/dynamic-updates.4bc790d0.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};